import React, { Component } from 'react'
import '../styles/custom.css'
import '../styles/footer.css'

class Header extends Component {

	render () {
		return (
			<div className="w-100 footer">
				<a href="https://www.allsafe-group.com/impressum/" style={{marginLeft: "1em"}}>Impressum</a>
				&nbsp;|&nbsp;<a href="https://www.allsafe24.com/company/dataprotection/dataprotection_read.action"
						 >Datenschutz</a>&nbsp;|&nbsp;Ein Service der <a href="https://www.allsafe-group.com"
		 						 >allsafe GmbH & Co. KG</a>
			</div>
		);
	}
}

export default Header;



// WEBPACK FOOTER //
// ./src/components/Footer.js